import SkeletonCard from "../../skeletons/SkeletonCard";

const CardActiveBotSkeleton = ({ isBotListPage }) => {
  return (
    <div
      className={`p-4 bg-white ${
        isBotListPage ? "border border-gray-200" : ""
      }  rounded-lg`}
    >
      <div className="flex justify-between items-start mb-3 w-full">
        <div className="w-full">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-gray-800 text-xl">
              <SkeletonCard
                type="text"
                lines={1}
                widths={["80px"]}
                heights={["20px"]}
              />
            </h3>
            <div className="flex items-center space-x-1">
              <SkeletonCard type="avatar" avatarSize={24} />
              <SkeletonCard
                type="text"
                lines={1}
                widths={["60px"]}
                heights={["20px"]}
              />
            </div>
          </div>
          <div className="flex items-center text-xs text-gray-500 mt-1">
            <div className="flex">
              <div>
                <SkeletonCard type="avatar" avatarSize={45} />
              </div>
              <div className="relative z-[0] ml-[-1rem]">
                <SkeletonCard type="avatar" avatarSize={45} />
              </div>
            </div>
            <span className="gap-2 flex whitespace-nowrap capitalize py-[2px] border-l-2 pl-2 ml-2">
              <SkeletonCard
                type="text"
                lines={1}
                widths={["40px"]}
                heights={["10px"]}
              />{" "}
              &middot;{" "}
              <SkeletonCard
                type="text"
                lines={1}
                widths={["40px"]}
                heights={["10px"]}
              />{" "}
            </span>
          </div>
        </div>
      </div>

      <div>
        <p className="text-base text-black font-medium mb-0.5">Investment</p>
        <div className="flex justify-between items-baseline">
          <div>
            {" "}
            <p className="text-xs text-gray-400 my-0">Starting Value</p>
            <span className="flex gap-2 text-sm font-semibold text-gray-800">
              <SkeletonCard
                type="text"
                lines={1}
                widths={["40px"]}
                heights={["8px"]}
              />{" "}
              USDT
            </span>
          </div>
          <div className="flex flex-col items-end">
            {" "}
            <p className="text-xs text-gray-400 text-right my-0">
              Current Value
            </p>
            <span className={`flex gap-2 text-sm font-bold text-[#007A78]`}>
              <SkeletonCard
                type="text"
                lines={1}
                widths={["40px"]}
                heights={["8px"]}
              />{" "}
              USDT
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardActiveBotSkeleton;
